import React from "react";
// import styles from "./NumberInput.module.css";
import CommonStyles from "../InputFieldsController/InputFieldsController.module.css";
import { Form } from "react-bootstrap";
import {
  FieldProps,
  getFieldContainerStyle,
} from "../InputFieldsController/InputFieldsController.utils";
import LabeledInputWrapper from "../InputFieldsController/LabeledInputWrapper";

interface NumberInputProps {
  field: FieldProps;
  handleChange: (fieldId: string, event: any) => void;
  handleBlur: (fieldId: string) => void;
  handleSelect: (fieldId: string) => void;
}

const NumberInput: React.FC<NumberInputProps> = ({
  field,
  handleChange,
  handleBlur,
  handleSelect,
}) => {
  const {
    id,
    placeholder,
    value,
    example,
    disabled,
    isValid = true,
    error,
    show = true,
    selected,
  } = field;

  if (!show) return null;

  const containerStyle = getFieldContainerStyle(field);

  return (
    <div style={containerStyle}>
      <LabeledInputWrapper field={field}>
        <Form.Control
          id={id}
          type="text"
          value={value ?? ""}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete="off"
          onChange={(e) => handleChange(id, e)}
          onBlur={() => handleBlur(id)}
          onFocus={() => handleSelect(id)}
          isInvalid={!isValid}
          className={`${CommonStyles.customInput} ${
            selected ? CommonStyles.selectedField : ""
          } ${disabled ? CommonStyles.disabledField : ""}`}
        />
        {!isValid && error && (
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        )}
      </LabeledInputWrapper>

      {example && <small className="text-muted">Example: {example}</small>}
    </div>
  );
};

export default NumberInput;
